"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNMOUNT = exports.COMMENT_ADDED = exports.POSTS_RECIEVED = exports.SINGLE_POST_OPEN = void 0;
const BaseStore = require("fluxible/addons/BaseStore");
const Entities_1 = require("../../backend/models/Entities");
const Requests_1 = require("../../backend/models/Requests");
class BlogStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.dispatcher = dispatcher;
        this.posts = new Entities_1.PagingResult();
        this.post = new Entities_1.SinglePostModel();
        this.page = 1;
        this.blogRequest = new Requests_1.BlogRequest();
    }
    handlePosts(container) {
        this.posts = container.result;
        this.blogRequest = container.request;
        this.page = parseInt(container.request.page, 10) || 1;
        this.randoms = container.randoms;
        this.emitChange();
    }
    handlePost(post) {
        this.post = post;
        this.emitChange();
    }
    addComment(comment) {
        if (comment.post === this.post._id) {
            this.post.comments.unshift(comment);
            this.emitChange();
        }
    }
    getPosts() {
        return this.posts;
    }
    getSinglePost() {
        return this.post;
    }
    getPageNum() {
        return this.page;
    }
    getRequestData() {
        return this.blogRequest;
    }
    setRandomsNull() {
        this.randoms = null;
    }
    getRandoms() {
        return this.randoms;
    }
    unmount() {
        this.post = new Entities_1.SinglePostModel();
    }
    handleRedirect(currentRoute) {
        if (currentRoute.name === 'blog') {
            this.page = parseInt(currentRoute.query.page, 10) || 1;
            this.emitChange();
        }
    }
    dehydrate() {
        return {
            posts: this.posts,
            post: this.post,
            page: this.page,
            blogRequest: this.blogRequest,
            randoms: this.randoms,
        };
    }
    rehydrate(state) {
        this.posts = state.posts;
        this.post = state.post;
        this.page = state.page;
        this.blogRequest = state.blogRequest;
        this.randoms = state.randoms;
    }
}
exports.SINGLE_POST_OPEN = 'SINGLE_POST_OPEN';
exports.POSTS_RECIEVED = 'POSTS_RECIEVED';
exports.COMMENT_ADDED = 'COMMENT_ADDED';
exports.UNMOUNT = 'UNMOUNT';
BlogStore.storeName = 'BlogStore';
BlogStore.handlers = {
    POSTS_RECIEVED: 'handlePosts',
    SINGLE_POST_OPEN: 'handlePost',
    COMMENT_ADDED: 'addComment',
    NAVIGATE_SUCCESS: 'handleRedirect',
    UNMOUNT: 'unmount',
};
exports.default = BlogStore;
